import React, { Component } from "react";
import * as ReactDOM from "react-dom";
import { Link } from 'react-router-dom';




import './App.css';
import './Complex_Imagry.css'


var x = 0;

function wack() {
  
  x+=1
  console.log("test");
  console.log(x)
  alert("Hey you have click " + x + " times");

  
}


class Item extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {

    console.log("Hardware Page");
  return (
   
    <div className="App">
   
      <header className="App-header">

      <div className="test_filter">
    
      </div>

      


    <button onClick={wack}>wow</button>
  
 




      





    
        
       
      </header>
    </div>
  );
}

}
export default Item;
